import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { InfoPopupComponent } from '@hrra/ui';
import { ConfirmationDialogComponent } from 'libs/ui/src/lib/confirmation-dialog/confirmation-dialog.component';
import {
  ConfirmActionDialogComponent,
  ConfirmActionDialogData,
} from 'libs/ui/src/lib/confirm-action-dialog/confirm-action-dialog.component';
import { ExceptionDialogComponent } from 'libs/ui/src/lib/exception-dialog/exception-dialog.component';
import {
  AnnouncementInviteResponseEnum,
  ApplicationMethodEnum,
  HRRAExceptionCode,
} from '@hrra/common-models';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog,  private translate: TranslateService) { }

  openConfirmDialog(msg){
    return this.dialog.open(ConfirmationDialogComponent, {
      // disableClose: true,
      panelClass: 'confirm-dialog-container',
      data:{
        message : msg
      },
      id: 'confirm'
    });
  }

  // Confirmation popup shown before an invitation status change is sent.
  // Title/description/button colour vary per chosen response (see Figma HR-3775).
  openInviteRespondConfirmDialog(responseStatus: AnnouncementInviteResponseEnum, applicationMethod?: ApplicationMethodEnum, isPublic = false){
    // For announcements that redirect to an external website, "Interested" does
    // not respond on that website, so the popup clarifies this and points to the
    // external apply button (HR-3900).
    const interestedDescription =
      (isPublic && applicationMethod === ApplicationMethodEnum.RedirectToUrl) 
        ? 'message.InviteRespondInterestedExternal'
        : 'message.InviteRespondInterested';

    const notInterestedDescription = (isPublic && applicationMethod === ApplicationMethodEnum.RedirectToUrl)
        ? 'message.InviteRespondNotInterestedExternal'
        : 'message.InviteRespondNotInterested';

    const dataMap: { [key: number]: ConfirmActionDialogData } = {
      [AnnouncementInviteResponseEnum.InterestedAndApplied]: {
        title: 'label.InvitationStatusInterestedAndApply',
        description: 'message.InviteRespondInterestedAndApply',
        confirmLabel: 'label.Approve',
        variant: 'primary',
      },
      [AnnouncementInviteResponseEnum.Interested]: {
        title: 'label.InvitationStatusInterested',
        description: interestedDescription,
        confirmLabel: 'label.Approve',
        variant: 'primary',
      },
      [AnnouncementInviteResponseEnum.NotInterested]: {
        title: 'label.InvitationStatusNotInterested',
        description: notInterestedDescription,
        confirmLabel: 'label.Approve',
        variant: 'danger',
      },
    };

    return this.dialog.open(ConfirmActionDialogComponent, {
      panelClass: 'confirm-action-dialog-container',
      autoFocus: false,
      data: dataMap[responseStatus],
      id: 'confirm-action',
    });
  }

  infoPopup(text, title){
    return this.dialog.open(InfoPopupComponent, {
      panelClass: 'info-dialog-container',
      autoFocus: false,
      data:{
        text : text,
        title: title
      },
      maxHeight: '100vh',
      id: 'info'
    });
  }

  openExeptionDialog(text, routerText, routerLink){
    return this.dialog.open(ExceptionDialogComponent, {
      panelClass: 'exeption-dialog-container',
      data:{
        message : text,
        routerText: routerText,
        routerLink: routerLink
      },
      id: 'exeption',
    });
  }

  getApplyFailedDialog(code){
    let routerText = this.translate.instant('label.GoToProfile');
    let routerLink = '/jobseeker/profile';
    let text: string;

    if(code == HRRAExceptionCode.ProfileIsIncomplete){
        text = this.translate.instant('message.ProfileIsIncomplete');
    }

    if(code == HRRAExceptionCode.ProfileIsPrivate){
        text = this.translate.instant('message.ProfileIsPrivate')
    }
    
    if(code == HRRAExceptionCode.CustomerIsBlackListed){
        text =  this.translate.instant('message.CannotApplyBlacklistedCompany')
    }

    return this.openExeptionDialog(text,  routerText,  routerLink)
  }

}
